import React from 'react'
import { HStack, VStack, Box, Image, Text, Button } from '@chakra-ui/react';
import b1 from '../img/book18/18-1.jpg';
import b2 from '../img/book18/18-2.jpg';
import b3 from '../img/book18/18-3.jpg';
import b4 from '../img/book18/18-4.jpg';
import b5 from '../img/book18/18-5.jpg';
import b6 from '../img/book18/18-6.jpg';
import b7 from '../img/book18/18-7.jpg';
import b8 from '../img/book18/18-8.jpg';
import b9 from '../img/book18/18-9.jpg';
import b10 from '../img/book18/18-10.jpg';
import b11 from '../img/book18/18-11.jpg';
import b12 from '../img/book18/18-12.jpg';
const Books18 = () => {
  return (
    <>
    <VStack spacing={4} align="stretch" alignItems={'center'} mt={4}>
      {/* ---------------------book1--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            borderColor="lightgray"
            bg={'#fff'}
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b1} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    عندما كنا عربًا
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الاسبانية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    حسني مليطات
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    إميليو فيرين
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    مدارك
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: E23 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b2} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    أزهار ألغرنون
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    آية علي
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    دانيال كيز
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    مدارك
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: E23 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            bg={'#fff'}
            borderRadius="10px"
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b3} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    مكتبة كولومبوس الضائعة
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    منير عليمي
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    إدوارد ويلسون لي
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    مدارك
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: E23 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
      {/* ---------------------book2--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b4} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    عن الغضب
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    محمد الشامي
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                        
                    لوسيوس سينيكا
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار: &nbsp;
                    <span>
                    مدارك
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: E23 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b5} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان: &nbsp;
                    <span>  
                    فلسفة السعادة
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    الألمانية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span>
                    أسامه أمين
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    تغريد الطاسان
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    مدارك
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: E23 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b6} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    الصمت في عصر الصخب
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    عبدالوهاب المقالح
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    إيرلنغ كيج
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    نادي الكتاب
                        
                    </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U18 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
      {/* ---------------------book3--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b7} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    عودي يانقودي
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    د. أمل العبود
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    زينة زيدان
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    دار زينة
                        </span>
                  </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b8} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    لا بأس
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    د. أمل العبود
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    زينة زيدان
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span> 
                    دار زينة
                        </span>
                  </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b9} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    الذات المنبثقة عن العقل
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span>
                    د. إيمان معروف
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    أنطونيو داماسيو
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span> 
                    دار الحكمة
                    </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: E21 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
      {/* ---------------------book4--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b10} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    الليبرالية السياسية
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span>
                    نوفل الحاج لطيف
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    جون رولز
                      </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    دار الحكمة
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: E21 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b11} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    مفاهيم الطب النفسي
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    د.يوسف الصمعان
                          </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    ناصر قائمي
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span> 
                    دار الحكمة
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: E21 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b12} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    ممسوس بالنار
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    هديل الدغيشم
                      </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    كاي ريدفيلد جيمسون
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    دار الحكمة
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: E21 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
    </VStack>
  </>
  )
}

export default Books18